import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Constants, {DashboardViewLayout, SortMetric} from '../../globals/Constants';
import LocalStorageWrapper from '../../services/LocalStorageWrapper/LocalStorageWrapper';
import Search from '../Search/Search';
import Strings from '../../globals/Strings';
import FilterTabsContainer from '../FilterTabs/FilterTabsContainer';
import Themeable from '../../types/Themeable';
import SortDirectionButton from '../SortDirectionButton/SortDirectionButton';

export default class LayoutBar extends React.Component<LayoutBarProps, {}> {
   constructor(props: LayoutBarProps) {
      super(props);
      autoBind(this);
   }

   showGridView() {
      this.props.setViewLayout(DashboardViewLayout.grid);
      LocalStorageWrapper.setItem(Constants.localStorageKeys.dashboardLayout, DashboardViewLayout[DashboardViewLayout.grid]);
   }

   showListView() {
      this.props.setViewLayout(DashboardViewLayout.list);
      LocalStorageWrapper.setItem(Constants.localStorageKeys.dashboardLayout, DashboardViewLayout[DashboardViewLayout.list]);
   }

   render() {
      const {searchText, setSearchText, viewLayout, themeName, reviewsSortMetric, setReviewsSortMetric} = this.props;

      return (
         <div className="layout-bar button-group">
            <FilterTabsContainer/>
            <div className="layout-controls">
               <Search setSearchText={setSearchText} placeholderText={Strings.labels.filter} searchText={searchText}/>
               <SortDirectionButton sortMetric={reviewsSortMetric} setSortMetric={setReviewsSortMetric} themeName={themeName} />
               <ControlButton
                  active={viewLayout === DashboardViewLayout.grid}
                  buttonType={TscButtonType.tertiary}
                  glyph={<Glyphs.ViewGrid24x24/>}
                  onClick={this.showGridView}
                  themeName={themeName}
                  title={Strings.labels.viewGrid}
                  testId="layout-bar-view-grid-button"
               />
               <ControlButton
                  active={viewLayout === DashboardViewLayout.list}
                  buttonType={TscButtonType.tertiary}
                  glyph={<Glyphs.ViewList24x24/>}
                  onClick={this.showListView}
                  themeName={themeName}
                  title={Strings.labels.viewList}
                  testId="layout-bar-view-list-button"
               />
            </div>
         </div>
      );
   }
}

export interface LayoutBarProps extends Themeable {
   viewLayout: DashboardViewLayout;
   searchText: string;
   reviewsSortMetric: SortMetric;
   setReviewsSortMetric(reviewsSortMetric: SortMetric): void;
   setSearchText(text: string): void;
   setViewLayout(layout: DashboardViewLayout): void;
}
